import { useReduxAlert } from '../../hooks'

const ReduxAlertProvider = () => {
  useReduxAlert()

  return null
}

export default ReduxAlertProvider
